module.exports = __webpack_public_path__ + "img/BR1.a6f61386.svg";